import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useMemo } from 'react';
import { Route, Routes, useLocation, useNavigate } from 'react-router-dom';
import { useContabilidadeDigitalData } from '@ibk/shared-config';
import { ApiProductStatus, AppDomain } from '@ibk/shared-types';
import { Loading } from '@ibk/shared-ui';
import ConsentFeedback from './ConsentFeedback/ConsentFeedback';
import ContabilidadeDigitalDasboard from './ContabilidadeDigitalDasboard/ContabilidadeDigitalDasboard';
import { LandingPageEmpresa } from './LandingPage/LandingPageEmpresa';
import { LandingPageEscritorio } from './LandingPage/LandingPageEscritorio';
export function createCdPaths(base = '/contabilidade-digital') {
    return {
        base: `${base}/contas-conectadas`,
        contract: `${base}/contas-conectadas/contratar`,
        authorize: `${base}/contas-conectadas/autorizar`,
        openFinance: `${base}/contas-conectadas/open-finance`,
    };
}
function getPath(cdPaths, domain, isActive, hasConnectedAccounts, isOpenFinance, pathname) {
    if (pathname.includes(cdPaths.openFinance))
        return pathname;
    if (domain === AppDomain.ESCRITORIO && !isActive) {
        return cdPaths.contract;
    }
    if (domain === AppDomain.EMPRESA) {
        if (isActive) {
            return isOpenFinance || hasConnectedAccounts ? cdPaths.base : cdPaths.authorize;
        }
        return '/';
    }
    return cdPaths.base;
}
export function ContabilidadeDigitalRouter({ domain, basePath = '/contabilidade-digital', }) {
    const cdPaths = useMemo(() => createCdPaths(basePath), [basePath]);
    const location = useLocation();
    const navigate = useNavigate();
    const { status, isLoading, connectedAccountsCount } = useContabilidadeDigitalData();
    useEffect(() => {
        if (isLoading)
            return;
        const isActive = status === ApiProductStatus.ACTIVE;
        const hasConnectedAccounts = connectedAccountsCount > 0;
        const isOpenFinance = location.pathname === cdPaths.base && location.search.includes('open-finance');
        const finalPath = getPath(cdPaths, domain, isActive, hasConnectedAccounts, isOpenFinance, location.pathname);
        if (location.pathname !== finalPath) {
            navigate(finalPath, { replace: true });
        }
    }, [status, isLoading, navigate, location.pathname, location.search, connectedAccountsCount, domain, cdPaths]);
    return (_jsxs(Routes, { children: [_jsx(Route, { index: true, element: isLoading ? _jsx(LoadingPage, {}) : _jsx(ContabilidadeDigitalDasboard, { domain: domain }) }), _jsx(Route, { path: 'contratar', element: isLoading ? _jsx(LoadingPage, {}) : _jsx(LandingPageEscritorio, {}) }), _jsx(Route, { path: 'autorizar', element: isLoading ? _jsx(LoadingPage, {}) : _jsx(LandingPageEmpresa, {}) }), _jsx(Route, { path: 'open-finance/:event/*', element: isLoading ? _jsx(LoadingPage, {}) : _jsx(ConsentFeedback, {}) })] }));
}
const LoadingPage = () => (_jsx("div", { style: { display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }, children: _jsx(Loading, {}) }));
export default ContabilidadeDigitalRouter;
